var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsRestoreIcon = function SvgDsRestoreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#DSRestoreIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2a6 6 0 1 1-4.242 10.243.667.667 0 0 0-.944.942A7.3 7.3 0 0 0 8 15.333 7.333 7.333 0 1 0 2.815 2.814c-.218.218-.517.537-.815.861v-1.6a.667.667 0 0 0-1.333 0v3.332a.664.664 0 0 0 .666.667h3.334a.667.667 0 1 0 0-1.333H2.832c.341-.374.691-.75.925-.984A5.98 5.98 0 0 1 8 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.667 5a.667.667 0 0 0-1.334 0v4c0 .198.088.385.24.512l2 1.667a.667.667 0 0 0 .854-1.024l-1.76-1.467z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "DSRestoreIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgDsRestoreIcon;